import { useEffect, useState } from 'react'

const MINUTE_IN_MS = 60 * 1000

// Plan boost gates compare expiresAt against the clock, so the UI has to tick to notice expiry
export const useCurrentTime = (enabled: boolean): Date => {
  const [now, setNow] = useState(() => new Date())

  useEffect(() => {
    if (!enabled) return
    setNow(new Date())
    const intervalId = setInterval(() => setNow(new Date()), MINUTE_IN_MS)
    return () => clearInterval(intervalId)
  }, [enabled])

  return now
}
